import FilterDialog from '../../../components/search/filter/FilterDialog';
import { Action, OperationType, Position } from '../../../dispatcher/Types';

export const resetSearch: Action = [{
  moduleName: 'SearchBar',
  name: 'setSearchValue',
  args: [''],
  type: OperationType.action
}];

export const saveActiveTabSearchBarValue: Action = [{
  evaluate: true,
  moduleId: '{tabPanelModuleId}',
  moduleName: 'TabPanel',
  name: 'getActiveTabUniqueValue',
  mappingName: 'activeTabUniqueValue',
  type: OperationType.addOperationData
}, {
  evaluate: true,
  moduleId: '{searchBarModuleId}',
  independent: true,
  moduleName: 'SearchBar',
  name: 'getSearchValue',
  mappingName: 'searchValue',
  type: OperationType.addOperationData
}, {
  independent: true,
  data: {
    template: {
      filterParams: {
        bind: {
          searchValue: '{searchValue}',
          params: '{params}',
          type: '{filterType}',
          filterData: '{filterData}',
          sort: '{sort}'
        }
      }
    }
  },
  type: OperationType.data
}, {
  evaluate: true,
  moduleId: '{moduleId}',
  independent: true,
  moduleName: 'Dashboard',
  name: 'saveActiveTabFilterParams',
  args: ['activeTabUniqueValue', 'filterParams']
}];

export const reloadGridWithTabConfig: Action = [{
  evaluate: true,
  moduleId: '{tabPanelModuleId}',
  moduleName: 'TabPanel',
  name: 'getActiveTabUniqueValue',
  mappingName: 'activeTabUniqueValue',
  type: OperationType.addOperationData
}, {
  independent: true,
  args: ['activeTabUniqueValue'],
  name: 'getActiveTabParams',
  moduleName: 'Dashboard',
  mappingName: 'activeTabParams',
  type: OperationType.addOperationData
}, {
  evaluate: true,
  independent: true,
  data: {
    template: {
      mask: 'self',
      bind: {
        reloadGridConfig: '{activeTabParams}',
        saveScroll: '!{activeTabParams}.params'
      }
    }
  },
  type: OperationType.data
}, {
  data: {
    update: {
      reloadGridConfig: {
        bind: {
          navigationGridModuleId: '"module_id_" + {activeTabUniqueValue}'
        }
      }
    }
  },
  type: OperationType.data
}, {
  independent: true,
  name: 'reloadGrid',
  type: OperationType.action
}];

/**
 * Triggers search
 */
export const triggerSearch: Action = [{
  name: 'saveActiveTabSearchBarValue',
  type: OperationType.action
}, {
  executeType: 'visible',
  displayed: true,
  args: ['params', 'url', 'method', 'saveScroll'],
  name: 'reloadGridData',
  moduleName: 'DashboardGrid'
}];

/**
 * Opens filters dialog
 */
export const OpenFilters: Action = [{
  executeType: 'visible',
  name: 'getFilterData',
  moduleName: 'DashboardGrid',
  mappingName: 'gridColumnFilterData',
  type: OperationType.addOperationData
}, {
  independent: true,
  name: 'GetSavedFilters',
  type: OperationType.action
}, {
  independent: true,
  data: {
    template: {
      label2: ' ',
      bind: {
        filterFields: '{filterConfig}.fields'
      }
    }
  },
  className: 'active-filter lg',
  children: [{
    render: FilterDialog,
    propArgs: ['savedFilters', 'filterFields', 'endPoints', 'gridColumnFilterData']
  }],
  items: [{
    operations: [{
      name: 'clearAll',
      moduleName: 'FilterDialog'
    }],
    btnName: 'FilterDialog.clearAll',
    btnConfig: {
      fillMode: 'outline',
      themeColor: 'primary',
      pos: Position.start
    },
    close: false
  }, {
    close: true,
    btnName: 'FilterDialog.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      name: 'SaveFilter',
      type: OperationType.action
    }],
    btnName: 'FilterDialog.saveFilter',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end,
      disabled: true
    },
    close: false
  }, {
    operations: [{
      data: {
        template: {
          saveScroll: false
        }
      },
      type: OperationType.data
    }, {
      name: 'FilterRequest',
      type: OperationType.action
    }],
    btnName: 'FilterDialog.filter',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    }
  }],
  title: 'FilterDialog.title',
  dialogName: 'FilterDialog',
  type: OperationType.dialog
}];
